module.exports = __webpack_public_path__ + "img/43.1f9c4c8e.png";